import { render, staticRenderFns } from "./VideoCopy.vue?vue&type=template&id=b7731044"
import script from "./VideoCopy.vue?vue&type=script&lang=js"
export * from "./VideoCopy.vue?vue&type=script&lang=js"
import style0 from "./VideoCopy.vue?vue&type=style&index=0&id=b7731044&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports